import { useEffect, useState } from "react";
import { t } from "./broker-sync-panel-format.util";

export function NumberSetting({
  label,
  value,
  min,
  max,
  onChange,
}: {
  label: string;
  /** The value that would be saved; `null` while the field holds an invalid entry. */
  value: number | null;
  min: number;
  max: number;
  onChange: (value: number | null) => void;
}) {
  const [text, setText] = useState(value === null ? "" : String(value));
  const parsed = text === "" ? Number.NaN : Number(text);
  const valid = Number.isInteger(parsed) && parsed >= min && parsed <= max;

  useEffect(() => {
    if (value !== null) setText(String(value));
  }, [value]);

  return (
    <label className="block space-y-1 text-sm font-medium">
      <span>{label}</span>
      <input
        type="number"
        min={min}
        max={max}
        value={text}
        onChange={(event) => {
          const next = event.target.value;
          setText(next);
          const nextNumber = next === "" ? Number.NaN : Number(next);
          onChange(Number.isInteger(nextNumber) && nextNumber >= min && nextNumber <= max ? nextNumber : null);
        }}
        aria-invalid={!valid}
        className="h-10 w-full rounded-md border bg-background px-3"
      />
      {!valid ? <span role="alert" className="block text-xs font-normal text-destructive">{t("portfolio.brokerSync.invalidNumber")}</span> : null}
      <span className="text-xs font-normal text-muted-foreground">{min}–{max}</span>
    </label>
  );
}
